var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconServices6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    clipPath: "url(#clip0_205_16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.03 57.31C44.6486 57.31 57.31 44.6486 57.31 29.03C57.31 13.4114 44.6486 0.75 29.03 0.75C13.4114 0.75 0.75 13.4114 0.75 29.03C0.75 44.6486 13.4114 57.31 29.03 57.31Z",
    fill: "white",
    stroke: "#8CC63F",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.93
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1998 43.7898L18.0698 35.8798H40.9598C41.0998 36.1498 41.3598 37.4598 41.4498 37.8398L42.8098 43.5798C42.8798 43.7398 42.8298 43.6898 42.9698 43.7798H45.9398C46.8698 43.7798 47.9298 43.9198 48.6098 43.4498C49.3198 42.9498 49.3798 42.2498 49.3798 41.2298C49.3798 39.6598 49.4498 26.9598 49.3598 26.3198H9.69977C9.61977 26.8798 9.64977 40.2398 9.69977 41.2298C9.72977 41.9998 9.53977 42.7798 10.4598 43.4498C11.1098 43.9298 12.2298 43.7798 13.1298 43.7798C14.1598 43.7798 15.1898 43.7798 16.2098 43.7798M43.6298 30.5798C43.1598 29.0098 45.4998 28.4298 45.9098 29.8898C46.3498 31.4398 44.0698 32.0398 43.6298 30.5798ZM43.6298 34.1998C43.1798 32.5798 45.5798 32.1398 45.9198 33.5698C46.2998 35.1498 44.0198 35.6198 43.6298 34.1998Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.47 14.56C19.08 14.78 18.54 14.75 17.7 15.33C16.77 15.98 13 20.98 11.99 22.21C11.62 22.67 11.26 23.12 10.87 23.61C10.61 23.94 9.86998 24.78 9.72998 25.1H49.32C49.17 24.77 43.1 17.25 42.6 16.65C41.93 15.83 41.62 15.35 40.55 14.89C40.26 14.77 39.85 14.71 39.58 14.55V9.80002L19.44 9.77002L19.46 14.54L19.47 14.56ZM20.74 11.01L38.35 11.03V20.77L20.69 20.74L20.74 11V11.01ZM19.47 20.22V21.96L39.55 21.99L39.57 20.22C40.09 20.33 40.4 20.6 40.61 20.97C41.73 22.95 40.87 22.59 37.98 22.59H19.31C18.02 22.59 17.46 22.64 18.42 20.96C18.63 20.59 18.95 20.32 19.46 20.21L19.47 20.22Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.99 45.8198H42.06C42.04 45.3798 40.52 39.2198 40.26 38.1198C40.19 37.8298 40.09 37.1398 39.92 37.0898H19.12C18.94 37.1398 18.85 37.8098 18.78 38.1198C18.52 39.1898 17.01 45.3998 16.98 45.8198M20.03 38.3298H39.02C39.15 38.5598 40.46 44.0598 40.53 44.6098H18.53C18.59 44.0698 19.91 38.5498 20.03 38.3298Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7596 43.2999C37.2796 43.2999 38.6696 43.5499 38.5596 42.7999C38.4996 42.3799 38.0696 42.4399 37.6696 42.4399H22.4896C21.9196 42.4399 20.5196 42.1899 20.6796 42.9799C20.7896 43.5199 22.2296 43.2999 22.7496 43.2999C23.5296 43.2999 24.2996 43.2999 25.0796 43.2999H36.7696H36.7596Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4199 40.66H33.8499C34.3999 40.68 36.9499 40.81 37.2199 40.53C37.3899 40.36 37.3499 40.04 37.1899 39.9C36.9599 39.72 34.9799 39.79 34.6299 39.8H24.4299C23.9099 39.8 23.3999 39.8 22.8799 39.8C22.2999 39.8 21.7799 39.72 21.9299 40.44C22.1099 40.78 23.8099 40.65 24.4299 40.65",
    fill: "#8CC63F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.05,
    height: 58.05,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServices6);
export default __webpack_public_path__ + "static/media/icon-services-6.2c267b67a221653e0e28f6e9c21dce4e.svg";
export { ForwardRef as ReactComponent };